import React, { useEffect, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { toast } from 'sonner';
import { Loader2 } from 'lucide-react';

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const API_URL = process.env.REACT_APP_BACKEND_URL;

const AuthCallback = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      // Check for session_id in URL hash (from Emergent Auth)
      const hash = window.location.hash;
      const sessionMatch = hash.match(/session_id=([^&]+)/);

      if (sessionMatch) {
        const sessionId = sessionMatch[1];
        try {
          const response = await fetch(`${API_URL}/api/auth/google-session`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ session_id: sessionId }),
          });

          if (!response.ok) {
            const errData = await response.json().catch(() => ({}));
            throw new Error(errData.detail || 'Authentication failed');
          }

          const data = await response.json();
          localStorage.setItem('littlelearners-token', data.access_token);

          if (data.is_new_user) {
            toast.success(`Welcome to Zazu, ${data.user?.name || 'there'}!`);
          } else {
            toast.success(`Welcome back, ${data.user?.name || 'there'}!`);
          }

          // Clear the hash and redirect
          window.location.href = '/dashboard';
          return;
        } catch (err) {
          console.error('Google session exchange failed:', err);
          toast.error(err.message || 'Google sign-in failed');
          navigate('/login');
          return;
        }
      }

      // Legacy: Check for token in query params (old OAuth flow)
      const token = searchParams.get('token');
      const error = searchParams.get('error');

      if (error) {
        toast.error(`Login failed: ${error}`);
        navigate('/login');
        return;
      }

      if (token) {
        localStorage.setItem('littlelearners-token', token);
        toast.success('Welcome to Zazu!');
        window.location.href = '/dashboard';
        return;
      }

      navigate('/login');
    };

    processAuth();
  }, [searchParams, navigate]);

  return (
    <div className="min-h-screen bg-gradient-to-b from-emerald-50 to-white flex items-center justify-center">
      <div className="text-center">
        <Loader2 className="w-12 h-12 animate-spin text-emerald-500 mx-auto mb-4" />
        <p className="text-slate-600" data-testid="auth-callback-loading">Completing sign in...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
